export type ClientType = 'GENERAL' | 'REAL_ESTATE';

export const DEFAULT_CLIENT_TYPE: ClientType = 'GENERAL';

export const CLIENT_TYPE_VALUES: ClientType[] = ['GENERAL', 'REAL_ESTATE'];
